  $( document ).ready(function() {

 
  if ($('.trust_logo_slider_one').length) {
    $('.trust_logo_slider_one').marquee({
      direction: 'left',
      duration: 80000,
      delayBeforeStart: 0,
      duplicated: true,
      gap: 0,
      startVisible: true
    });
  }
  if ($('.trust_logo_slider_two').length) {
    $('.trust_logo_slider_two').marquee({
      direction: 'right',
      duration: 80000,
      delayBeforeStart: 0,
      duplicated: true,
      gap: 0,
      startVisible: true
    });
  }
  if ($('.trust_logo_slider_three').length) {
    $('.trust_logo_slider_three').marquee({
      direction: 'left',
      duration: 120000,
      delayBeforeStart: 3000,
      duplicated: true,
      gap: 0,
      startVisible: true
    });
  }
 })